import React from 'react';

import Image from '@/components/Image/Image';

import styles from './styles.module.css';

const BonnesPratiquesPi: React.FC<BonnesPratiquesPiProps> = ({
  isValid,
  defaultSrc,
  webpSrc,
  legende,
  textOverImg,
  effect,
}) => {
  return (
    <div className={styles.bestPracticesPi}>
      <div className={styles.bestPracticesPiTop}>
        <div
          className={`${styles.bestPracticesPiCoche} ${isValid ? styles.bestPracticesPiSuccess : styles.bestPracticesPiError}`}
        >
          {isValid ? <i className="totem-icon totem-icon-check" /> : <i className="totem-icon totem-icon-cross" />}
        </div>
        <Image defaultSrc={defaultSrc} webpSrc={webpSrc} alt={legende} effect={effect} />
        {textOverImg && <span>{textOverImg}</span>}
      </div>
      <div
        className={`${styles.bestPracticesPiLegende} ${isValid ? styles.bestPracticesPiSuccess : styles.bestPracticesPiError}`}
      >
        <span>{legende}</span>
      </div>
    </div>
  );
};

export interface BonnesPratiquesPiProps {
  isValid: boolean;
  defaultSrc: string;
  webpSrc: string;
  legende: string;
  textOverImg?: string;
  effect?: 'blur' | 'blackWhite';
}

export default BonnesPratiquesPi;
